import React, { useState } from "react";
import { Box, Button } from "@mui/material";

import { COLUMNS } from "../../constants";
import { useSearchCustomersContext, useAdminProviderDataContext } from "../../../../context";
import ExportCsv from "../../ExportCsv";
import TableColumnsView from "../../../../components/ui/TableColumnsView";
import MainFilters from "../MainFilters";
import { DiscountsModal } from "../../../../components/ui";

interface IProps {
  keyVal: number;
  setKey: (k: number) => void;
}

const ViewTableControlsAndActions: React.FC<IProps> = ({ keyVal, setKey }) => {
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();
  const {
    relatedTables,
    setRelatedTables,
    setSearch,
    setShowInactiveAccounts,
    setIsShowActiveSubscription,
    setIsShowLeads,
    setIsShowPassedEvaluations,
    setIsShowBanned,
    setIsShowAbandoned,
  } = useSearchCustomersContext();

  const [isOpenDiscountModal, setIsOpenDiscountModal] = useState(false);

  const handleShowExternalColumns = (value: string[]) => setRelatedTables(value);
  const handleOpenDiscountModal = () => setIsOpenDiscountModal(true);
  const handleClearFilters = () => {
    setSearch({ email: "" });
    setShowInactiveAccounts(true);
    setIsShowActiveSubscription(true);
    setIsShowLeads(false);
    setIsShowPassedEvaluations(true);
    setIsShowBanned(true);
    setIsShowAbandoned(true);
    setKey(keyVal + 1);
  };

  return (
    <>
      {allowed_features.batch_create_codes_for_customers && (
        <DiscountsModal setIsOpen={setIsOpenDiscountModal} isOpen={isOpenDiscountModal} />
      )}

      <div>
        <Box display="flex" justifyContent="space-between" mb="20px">
          <div>
            <TableColumnsView
              relatedTables={relatedTables}
              handleShowExternalColumns={handleShowExternalColumns}
              columns={COLUMNS}
            />

            <MainFilters />
          </div>

          <div>
            {allowed_features.batch_create_codes_for_customers && (
              <Button data-test="button-create-codes" onClick={handleOpenDiscountModal}>
                Create discounts for current users
              </Button>
            )}
            {allowed_features.export_customers_csv && <ExportCsv data-test="button-export-csv" />}

            <Box display="flex" justifyContent="end" mt="20px">
              <Button onClick={handleClearFilters}>Clear filters</Button>
            </Box>
          </div>
        </Box>
      </div>
    </>
  );
};

export default ViewTableControlsAndActions;
